import React from 'react';
import { useModal } from '../../../context/ModalContext';
import { ModalBase } from './ModalBase';

export function PartnerDetailModal() {
  const { selectedPartner } = useModal();

  if (!selectedPartner) return null;

  const badgeStyle: React.CSSProperties = {
    fontSize: '11px',
    fontWeight: 700,
    padding: '3px 10px',
    borderRadius: '20px',
    background: selectedPartner.open ? '#B4FFE7' : '#F0F0F0',
    color: selectedPartner.open ? '#275849' : '#8a8a8a',
  };

  return (
    <ModalBase>
      <h3 className="modal-box__title">{selectedPartner.name}</h3>
      <div style={{ fontSize: '13px', color: '#727272', marginBottom: '14px' }}>
        {selectedPartner.address}
      </div>

      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', alignItems: 'center' }}>
        <span style={{ fontSize: '13px', fontWeight: 700, color: '#E99000' }}>
          ★ {selectedPartner.rating}
        </span>
        <span style={badgeStyle}>
          {selectedPartner.open ? 'Aberto' : 'Fechado'}
        </span>
        <span style={{ fontSize: '12.5px', color: '#8a8a8a' }}>
          {selectedPartner.distance}
        </span>
      </div>

      <div style={{ fontSize: '13px', fontWeight: 700, marginBottom: '8px' }}>
        Serviços disponíveis
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '24px' }}>
        {selectedPartner.services.map((service) => (
          <span
            key={service}
            style={{
              background: '#F0F0F0',
              color: '#2F3857',
              fontSize: '12px',
              fontWeight: 600,
              padding: '6px 12px',
              borderRadius: '20px',
            }}
          >
            {service}
          </span>
        ))}
      </div>

      <p style={{ fontSize: '13px', color: '#727272', lineHeight: 1.5, margin: '0 0 14px' }}>
        Para lavar neste parceiro, escaneie o QR Code da sua assinatura pelo aplicativo WashPass.
      </p>

      <button className="modal-form__submit" style={{ marginBottom: '10px' }}>
        Abrir o app
      </button>
      <button
        className="modal-form__submit"
        style={{ background: '#fff', color: '#12A9DC', border: '1.5px solid #12A9DC' }}
      >
        Baixar o app
      </button>
    </ModalBase>
  );
}
